import { render, staticRenderFns } from "./residents-vital-signs.vue?vue&type=template&id=3b4e49e5&"
import script from "./residents-vital-signs.vue?vue&type=script&lang=js&"
export * from "./residents-vital-signs.vue?vue&type=script&lang=js&"
import style0 from "./residents-vital-signs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports